import { useQuery } from "@tanstack/react-query";
import type { SwimmerType } from "../../../api/client/types/swimmer-type.types";
import type { ApiError } from "../../../api/client/types/common.types";
import { swimmerTypeEndpoints } from "../../../api/endpoints/swimmer-type";

/**
 * React Query Keys
 * Organized keys help with cache invalidation and devtools debugging.
 */
const swimmerTypeQueryKeys = {
  root: ["swimmer-types"] as const,
  list: () => [...swimmerTypeQueryKeys.root, "list"] as const,
  detail: (id: number) => [...swimmerTypeQueryKeys.root, "detail", id] as const,
};

/**
 * Hook: useGetSwimmerTypes
 * Fetches all swimmer types.
 */
export const useGetSwimmerTypes = () => {
  return useQuery<SwimmerType[], ApiError>({
    queryKey: swimmerTypeQueryKeys.list(),
    queryFn: () => swimmerTypeEndpoints.getSwimmerTypes(),
  });
};

export const useGetSwimmerTypeById = (id: number) => {
  return useQuery<SwimmerType, ApiError>({
    queryKey: swimmerTypeQueryKeys.detail(id),
    queryFn: () => swimmerTypeEndpoints.getSwimmerTypeById(id),
  });
};
